import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}
const links = [{
  label: 'HOME',
  href: '#index'
}, {
  label: 'STUDIO',
  href: '#studio'
}, {
  label: 'PRACTICE',
  href: '#practice'
}, {
  label: 'RESONANCE',
  href: '#resonance'
}, {
  label: 'BEGIN',
  href: '#begin'
}];
export function MobileMenu({
  isOpen,
  onClose
}: MobileMenuProps) {
  return <AnimatePresence data-id="element-227">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.4
    }} className="fixed inset-0 z-50 bg-ink flex flex-col justify-center items-center" data-id="element-228">
          <button onClick={onClose} className="absolute top-6 right-6 text-parchment p-4 font-mono text-xl" aria-label="Close menu" data-id="element-229">
            ×
          </button>

          <nav className="flex flex-col items-center gap-8" data-id="element-230">
            {links.map((link, i) => <motion.a key={link.label} href={link.href} onClick={onClose} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1 + i * 0.1,
          duration: 0.4
        }} className="font-mono text-parchment text-lg tracking-[0.2em] uppercase p-4" data-id="element-231">
                {link.label}
              </motion.a>)}
          </nav>
        </motion.div>}
    </AnimatePresence>;
}